export default {
  required: 'Pole wymagane',
  incompleteFieldList: 'Najpierw uzupełnij: {fields}',
  unboundIssueListHeader: 'Popraw przed zapisem',
  discardHeader: 'Odrzucić niezapisane zmiany?',
  discardMessage: 'Spowoduje to usunięcie wszystkich zmian od ostatniego zapisu.',
};
